import { render } from "./ReviewViewer.vue?vue&type=template&id=2608393e&scoped=true&ts=true"
import script from "./ReviewViewer.vue?vue&type=script&lang=ts"
export * from "./ReviewViewer.vue?vue&type=script&lang=ts"

import "./ReviewViewer.vue?vue&type=style&index=0&id=2608393e&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2608393e"]])

export default __exports__